"use strict";
import {on, findAllIn} from '../../libs/@elements/dom-utils';
import {onFind} from "../../libs/@elements/init-modules-in-scope";

export function init() {
    onFind('.js-ajax-form-map-google__result',(baseElement)  => {
        findAllIn('.js-ajax-form-map-google__item', baseElement).forEach((element) => {
            on('click', function () {
                window.dataLayer.push({
                    'event': element.getAttribute('data-event-tracking-event'),
                    'action': element.getAttribute('data-event-tracking-action'),
                    'select_item': element.getAttribute('data-event-tracking-select_item'),
                    'link_url': element.getAttribute('data-event-tracking-link_url'),
                });
            }, element);
        });
    });
}
